import getUserMailboxInfo from 'owa-client-ids/lib/utils/getUserMailboxInfo';
import { PerformanceDatapoint as BasePerformanceDatapoint } from 'owa-analytics';
import type { DatapointOptionsForPerformanceDatapoint } from 'owa-analytics-types';

export class PerformanceDatapoint extends BasePerformanceDatapoint {
    constructor(eventName: string, options?: DatapointOptionsForPerformanceDatapoint) {
        super(eventName, getUserMailboxInfo(), options);
    }
}
